module.exports = __webpack_public_path__ + "static/media/better-job-fit-james.4d01ae7f.jpg";